import React, { useState, useEffect } from 'react';
import { Container, styled, useMediaQuery } from '@mui/material';
import logoFull from '../assets/logo/LogoFull.png';
import logoSmall from '../assets/logo/LogoSmall.png';

interface HeaderWrapperProps {
  $isHidden: boolean;
}

const HeaderWrapper = styled('div')<HeaderWrapperProps>(({ $isHidden }) => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 1000,
  backgroundColor: '#FFFFFF',
  pointerEvents: $isHidden ? 'none' : 'auto',
  transition: 'transform 0.4s ease, opacity 0.4s ease',
  transform: $isHidden ? 'translate3d(0, -100%, 0)' : 'translate3d(0, 0, 0)',
  opacity: $isHidden ? 0 : 1,
}));

const HeaderContainer = styled('nav')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '20px 0px',
});

const LogoBranding = styled('div')({
  height: 'var(--uicore-header--logo-h, 40px)',
  position: 'relative',
});

const LogoLink = styled('a')({
  display: 'block',
  height: 'inherit',
  textDecoration: 'none',
});

const LogoImage = styled('img')({
  height: '40px',
  maxWidth: 'unset',
  display: 'block',
  '@media (max-width: 767px)': {
    height: '32px',
  },
});

const Header: React.FC = () => {
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <HeaderWrapper $isHidden={isHidden}>
      <Container maxWidth="xl" sx={{ width: '90%', mx: 'auto' }}>
        <HeaderContainer>
          <LogoBranding>
            <LogoLink href="#">
              <LogoImage
                src={isMobile ? logoSmall : logoFull}
                alt="AKRBIT SIA"
              />
            </LogoLink>
          </LogoBranding>
        </HeaderContainer>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
